<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">审核管理</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">课程审核</a>
        </span>
      </div>
      <div class="framePage-body">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabsChange">
          <el-tab-pane label="待审核" name="first">
            <CourseToBeReviewed ref="first" />
          </el-tab-pane>
          <el-tab-pane label="已通过" name="second">
            <Coursepassed ref="second" />
          </el-tab-pane>
          <el-tab-pane label="已驳回" name="three">
            <CourseRejected ref="three" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import CourseToBeReviewed from "@/views/AuditManagement/CourseToBeReviewed.vue";
import Coursepassed from "@/views/AuditManagement/Coursepassed.vue";
import CourseRejected from "@/views/AuditManagement/CourseRejected.vue";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "CourseReview",
  components: {
    CourseToBeReviewed,
    Coursepassed,
    CourseRejected
  },
  mixins: [List],
  data() {
    return {
      activeName: "first"
    };
  },
  created() {},
  mounted() {
    this.activeName = this.$route.query.activeName || "first";
  },
  methods: {
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName }
      });
    },
    tabsChange(e) {
      this.$refs[e.name].ruleForm.Trainingtype = "";
      this.$refs[e.name].params = {};
      this.$refs[e.name].courseName = "";
      this.$refs[e.name].compSourceId = "";
      this.$refs[e.name].compId = "";
      this.$refs[e.name].getData(-1);
    }
  },
  beforeRouteLeave: resetKeepAlive,
  watch: {
    $route: function(route) {
      if (route.query.refresh) {
        this.$refs[route.query.activeName].getData(-1);
      }
    }
  }
};
</script>
<style lang="less">
.searchBox {
  .el-icon-arrow-down:before {
    content: "\e6df" !important;
  }
}
</style>
